<template>
  <div>
    <transition name="bounce" enter-active-class="bounceInDown" leave-active-class="none">
      <div class="djzx" ref="djzk" v-show="show">
        <div class="title-bj">
          <div class="liuyan">请您留言</div>
          <div class="xiaochuang" @click="hide"></div>
        </div>
        <div class="title">
          <p class="title-jy">河南简云网络科技有限公司</p>
          <p class="title-dh">400-8086-828</p>
        </div>
        <div style="padding: 10px 10px 0 10px;">
        <textarea class="wbk" type="text" v-model="formInline.liuyantext" placeholder="请在此输入留言内容,我们会尽快与您联系(必填)">
            </textarea></div>
        <ul style="list-style: none">
          <li style="padding: 3px 10px;"><Input type="text" v-model="formInline.name" placeholder="姓名(必填)">
            <Icon class="iconfont icon-ren bjtb" slot="prepend"></Icon>
            </Input></li>
          <li style="padding: 3px 10px;"><Input type="text" v-model="formInline.phone" placeholder="电话(必填)">
            <Icon class="iconfont icon-dianhua bjtb" slot="prepend"></Icon>
            </Input></li>
          <li style="padding: 3px 10px;"><Input type="text" v-model="formInline.mail" placeholder="邮箱">
            <Icon class="iconfont icon-youxiang bjtb" slot="prepend"></Icon>
            </Input></li>
          <li style="padding: 3px 10px;"><Input type="text" v-model="formInline.adress" placeholder="地址">
            <Icon class="iconfont icon-dizhi bjtb" slot="prepend"></Icon>
            </Input></li>
        </ul>
        <div style="height: 15px;"></div>
        <Button class="button" type="primary" @click="handleSubmit()">发送</Button>
      </div>
    </transition>
    <transition name="fade">
      <div class="xck-title" v-show="display">
        <div class="liuyan">请您留言</div>
        <div class="xiaochuang zhankai" @click="zhanshi"></div>
      </div>
    </transition>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        modal1: false,
        display: false,
        show: false,
        formInline: {
          liuyantext: '',
          name: '',
          phone: '',
          mail: '',
          adress: '',
        },
        ruleInline: {
          liuyantext: [
            {required: false, message: '留言内容不可为空', trigger: 'blur'},
          ],
          name: [
            {required: false, message: '姓名不可为空', trigger: 'blur'},
          ],
          phone: [
            {required: false, message: '电话不可为空', trigger: 'blur'},
            {type: 'string', min: 11, max: 11, message: '电话号码格式不对', trigger: 'blur'}

          ]

        }
      }
    },
    methods: {
      hide() {
        this.show = false,
          this.display = true
      },
      zhanshi() {
        this.show = true,
          this.display = false
      },
      handleSubmit() {
        let that = this;

        if (that.formInline.liuyantext === "") {
          return this.$Message.error('请输入留言内容');
        }
        if (that.formInline.name === "") {
          return this.$Message.error('请输入姓名');
        }
        if (that.formInline.phone === "") {
          return this.$Message.error('请输入联系方式');
        }
        let url = that.baseUrl + '/jianyunadmin/api.php?c=contact_us';
        that.axios.get(url, {
          params: {
            cooperation_contacts: that.formInline.name,
            cooperation_phone: that.formInline.phone,
            cooperation_content: that.formInline.liuyantext
          }
        }).then(res => {
          console.log(res);
          if (res.data.success) {
            this.$Message.success('提交成功');
          } else {
            this.$Message.warning(res.data.msg);
          }

        }).catch(error => {
          console.log(error);
        })


      }
    }

  }

</script>
<style scoped>
  .djzx {
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -120px;
    margin-top: -210px;
    z-index: 999;
    width: 240px;
    height: 410px;
    background-color: #ededed;
    border-radius: 5px;
    color: #000;
    text-align: center;
    border-radius: 5px;
    /*display: none;*/
  }

  .title-bj {
    background: #65B6EA url(//sgoutong.baidu.com/embed/1563279891/asset/embed/css/pc/message/img/boardTop8.png) no-repeat;
    height: 35px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .liuyan {
    float: left;
    font-size: 14px;
    color: #fff;
    margin-left: 12px;
    line-height: 35px
  }

  .xiaochuang {
    float: right;
    height: 30px;
    width: 34px;
    margin-top: 2px;
    cursor: pointer;
    background: transparent url(//sgoutong.baidu.com/embed/1563279891/asset/embed/css/pc/message/img/nodeMin.png) no-repeat;
  }

  .wbk {
    width: 221px;
    height: 80px;
    resize: none;
    overflow: hidden;
    border: 1px solid #d5d5d5;
    background-color: #fff;
    line-height: 15px;
    padding: 5px;
    border-radius: 5px;
  }

  .form-wbk {
    margin-top: 12px;
    margin-bottom: 0;
  }

  .form-width {
    width: 221px;
    margin-bottom: 10px;
  }

  .title {
    text-align: left;
    padding: 12px 0 12px 12px;
    border-bottom: 1px solid #d5d5d5;
  }

  .title-jy {
    font-size: 14px;
    color: #666;
  }

  .title-dh {
    color: #999;
  }

  .djzx .button {
    margin-left: -130px;
    background-color: #DA9475;
    width: 90px;
    height: 35px;
    border: none;
    font-size: 14px;
  }

  /*缩小后样式*/
  .xck-title {
    position: fixed;
    left: 0;
    bottom: 5px;
    background: #65B6EA url(//sgoutong.baidu.com/embed/1563279891/asset/embed/css/pc/message/img/boardTop8.png) no-repeat;
    width: 240px;
    height: 35px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .zhankai {
    background: transparent url(//sgoutong.baidu.com/embed/1563279891/asset/embed/css/pc/message/img/nodeMax.png) no-repeat;
  }

  /*修改ui框架中样式*/
  .ivu-form-item-error-tip {
    font-size: 20px;
  }

  .ivu-form {
    padding-left: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/components/tankuang.vue